var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.133,
    height: 22,
    viewBox: "0 0 22.133 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo-facebook",
    d: "M54.133,44.416a11.066,11.066,0,1,0-12.8,10.933V47.616H38.527v-3.2h2.811V41.978c0-2.773,1.653-4.306,4.18-4.306a17.006,17.006,0,0,1,2.478.216v2.724H46.6a1.6,1.6,0,0,0-1.8,1.729v2.075h3.069l-.49,3.2H44.8V55.35A11.069,11.069,0,0,0,54.133,44.416Z",
    transform: "translate(-32 -33.35)",
    fill: "#ffd536",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.c791dca769fa1b38d56a01112c6755ab.svg";
export { ForwardRef as ReactComponent };